import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { FAQ_ITEMS } from '../data/faq.data';

export type ButtonColor = 'primary' | 'secondary';

@Component({
  selector: 'lumiron-accordion',
  templateUrl: 'accordion.component.html',
  styleUrl: './accordion.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbAccordionModule],
})
export class AccordionComponent {
  protected readonly faqItems = FAQ_ITEMS;
}
